import { Job } from '../actions'

export const UPDATE_JOB = 'UPDATE_JOB'
export const UPDATE_JOB_PENDING = 'UPDATE_JOB_PENDING'
export const UPDATE_JOB_FULFILLED = 'UPDATE_JOB_FULFILLED'
export const UPDATE_JOB_REJECTED = 'UPDATE_JOB_REJECTED'
export const REMOVE_JOB = 'REMOVE_JOB'

export const GET_ALL_JOBS = 'GET_ALL_JOBS'
export const GET_ALL_JOBS_PENDING = 'GET_ALL_JOBS_PENDING'
export const GET_ALL_JOBS_FULFILLED = 'GET_ALL_JOBS_FULFILLED'
export const GET_ALL_JOBS_REJECTED = 'GET_ALL_JOBS_REJECTED'

export const GET_JOB_TEMPLATE = 'GET_JOB_TEMPLATE'
export const GET_JOB_TEMPLATE_PENDING = 'GET_JOB_TEMPLATE_PENDING'
export const GET_JOB_TEMPLATE_FULFILLED = 'GET_JOB_TEMPLATE_FULFILLED'
export const GET_JOB_TEMPLATE_REJECTED = 'GET_JOB_TEMPLATE_REJECTED'

export const CREATE_JOB = 'CREATE_JOB'
export const CREATE_JOB_PENDING = 'CREATE_JOB_PENDING'
export const CREATE_JOB_FULFILLED = 'CREATE_JOB_FULFILLED'
export const CREATE_JOB_REJECTED = 'CREATE_JOB_REJECTED'

export const DELETE_JOB_BY_ID = 'DELETE_JOB_BY_ID'
export const DELETE_JOB_BY_ID_PENDING = 'DELETE_JOB_BY_ID_PENDING'
export const DELETE_JOB_BY_ID_FULFILLED = 'DELETE_JOB_BY_ID_FULFILLED'
export const DELETE_JOB_BY_ID_REJECTED = 'DELETE_JOB_BY_ID_REJECTED'

export const GET_JOB_BY_ID = 'GET_JOB_BY_ID'
export const GET_JOB_BY_ID_PENDING = 'GET_JOB_BY_ID_PENDING'
export const GET_JOB_BY_ID_FULFILLED = 'GET_JOB_BY_ID_FULFILLED'
export const GET_JOB_BY_ID_REJECTED = 'GET_JOB_BY_ID_REJECTED'

export const GET_OPEN_JOBS = 'GET_OPEN_JOBS'
export const GET_OPEN_JOBS_PENDING = 'GET_OPEN_JOBS_PENDING'
export const GET_OPEN_JOBS_FULFILLED = 'GET_OPEN_JOBS_FULFILLED'
export const GET_OPEN_JOBS_REJECTED = 'GET_OPEN_JOBS_REJECTED'

export type AddOrUpdateJobsActions =
  | typeof UPDATE_JOB_FULFILLED
  | typeof CREATE_JOB_FULFILLED
  | typeof DELETE_JOB_BY_ID_FULFILLED
  | typeof REMOVE_JOB

export type DeleteJobResponse = {
  data: {
    message: string
  }
  success?: boolean
  statusCode?: number
}

export type UpdateJobResponse = {
  data: {
    message: string
    job: Job
  }
  success: boolean
  statusCode: number
}

export type GetJobResponse = {
  data: Job
  success?: boolean
  statusCode?: number
}

export type OpenJob = {
  id: number
  title_en: string
  title_ar: string
  title_i18n: string
}

export type GetPublicJobsReponse = {
  data: OpenJob[]
  success?: boolean
  statusCode?: number
}
